module.exports = __webpack_public_path__ + "img/tzzm.01ad8282.png";